import React from "react";
import UserConstantsHelper from '../../helpers/constants/user'
import LocationV2Icon from '../../images/icons/location_v2.svg?react';

const Location = ({ city, country, is_traveling, traveling_location, color, fontSize = 12, className = "", locationV2Icon, containerClassName }) => {
  const isDark = localStorage.getItem("isDark") === "true";
  const locationColor = color ? color : isDark ? "#fff" : "#000";

  let location = 'Not Available';
  if (UserConstantsHelper.isUserTraveling({ is_traveling })) {
    location = traveling_location
  } else {
    if (city && country) {
      location = `${city}, ${country}`;
    } else if (city) {
      location = city;
    } else if (country) {
      location = country;
    }
  }

  return (
    <div className={`${containerClassName} ${locationV2Icon ? "d-flex align-items-start justify-content-center gap-1" : "" }`}>
      {
        locationV2Icon ? (
          <div>
            <LocationV2Icon />
          </div>
        ) : (
          <i
            className="fas fa-map-marker-alt"
            style={{
              color: locationColor,
              marginRight: '5px',
              fontSize: `${fontSize}px`,
            }}
          ></i>
        )
      }
      <span
        className={className}
        style={{
          color: locationColor,
          fontSize: `${fontSize}px`,
        }}>
        {location}
      </span>
    </div>
  );
}

export default Location;
